import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CssBaseline, Grid, OutlinedInput, InputAdornment, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import Topbar from '../components/Topbar';

const styles = (theme) => ({
  bg: {
    backgroundColor: 'rgb(243,243,243)',
    height: 'calc(100vh - 84px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 170px)',
      display: 'block',
      overflow: 'auto',
    },
  },

  formOuter: {
    width: '80vw',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '90vw',
      paddingTop: 20,
    },
  },
  cateOuter: {
    width: '80vw',
    margin: '0 auto',
    minHeight: 444,
    [theme.breakpoints.down('sm')]: {
      width: '90vw',
    },
  },
  menuItem: {
    backgroundColor: 'white',
    // width: '19%',
    height: 140,
    textAlign: 'center',
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '1.1em',
    borderRadius: 5,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 15,
      marginRight: 0,
    },
  },
  cardsWrap: {
    display: 'flex',
    alignItems: 'center',
    //height: 'calc(100vh - 84px)',

    [theme.breakpoints.down('sm')]: {
      alignItems: 'baseline',
      overflowY: 'auto',
    },
  },
});

class PosterCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      posterCategories: [],
      filteredCategories: [],
      searchkeyword: '',
    };
    this.renderCategories = this.renderCategories.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        posterCategories: JSON.parse(sessionStorage.getItem('Item')).poster,
        filteredCategories: JSON.parse(sessionStorage.getItem('Item')).poster,
      },
      () => {
        console.log(this.state.posterCategories);
      },
    );
  }
  moveToCategory(idx) {
    this.props.history.push(`poster/${idx}`);
  }
  renderCategories(datas) {
    return datas.map((cate, idx) => (
      <Grid item xs={6} md={2} key={`category-key-${idx}`} onClick={() => this.moveToCategory(idx)}>
        <div className={this.props.classes.menuItem}>{cate}</div>
      </Grid>
    ));
  }
  inputChange = (event) => {
    //const { searchkeyword, posterCategories } = this.state;
    this.setState({ searchkeyword: event.target.value.toLowerCase() }, () => {
      const _filteredCategories = this.state.posterCategories.filter((el) => el.toLowerCase().indexOf(this.state.searchkeyword) !== -1);
      this.setState({ filteredCategories: _filteredCategories });
    });
  };
  render() {
    const { classes } = this.props;
    const { filteredCategories } = this.state;

    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar />

        <div className={classes.bg}>
          <div>
            <div style={{ marginBottom: '1em', textAlign: 'right' }} className={classes.formOuter}>
              <form onSubmit={this.handleSubmit}>
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">
                      <IconButton disabled>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                  placeholder="검색"
                  value={this.state.searchkeyword}
                  onChange={this.inputChange}
                  className={classes.searchBar}
                  style={{ backgroundColor: '#fff' }}
                />
              </form>
            </div>
            <div className={classes.cardsWrap}>
              <Grid container spacing={1} className={classes.cateOuter}>
                {filteredCategories && this.renderCategories(filteredCategories)}
              </Grid>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PosterCategory);
